// LiveStreamCard.js
import { connect } from 'react-redux';

import getUsername from '../selector/getUsername.js';
import getUserData from '../selector/getUserData.js';
import getFormattedLiveStreamViewers from '../selector/getFormattedLiveStreamViewers.js';
import getMeData from '../selector/getMeData.js';
import getLiveStreamLanguageBadges from '../selector/getLiveStreamLanguageBadges.js';
import getUserBadges from '../selector/getUserBadges.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import {
  getIsToyDeviceOnline,
  getIsAudioLive,
} from '../selector/getLivestreamComputedData.js';

import fetchUser from '../action/fetchUser.js';
import fetchLiveStreamAvailability from '../action/fetchLiveStreamAvailability.js';
import fetchTranslationByKey from '../action/fetchTranslationByKey.js';
import { push, replace } from '../action/navigationAction.js';
import fetchRetainedEvents from '../action/fetchRetainedEvents.js';

import withRouter from '../component/WithRouter.jsx';
import LiveStreamCard from '../component/LiveStreamCard.jsx';
import i18n from '../resource/i18n.js';
import getCurrentLanguage from '../resource/getCurrentLanguage.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import getPublicUrlHostname from '../selector/getPublicUrlHostname.js';
import {
  PUBLIC_BADGE_URL_PATH,
  LIVESTREAM_FEED,
  FEATURE_LIVESTREAM_SNAPSHOT,
} from '../RemoteConfigKeys.js';
import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';

const mapStateToProps = (
  state,
  { userId, streamId, location: { pathname } }
) => {
  const username = getUserData(state, userId, 'username');
  const formattedViewers = getFormattedLiveStreamViewers(state, streamId);
  const meId = getMeData(state, 'id');
  const isAuthed = !!meId;
  const [locationBadge] = getUserBadges(state, userId, 'locations');
  const locationKey = locationBadge?.replace?.(':', '_') || '';
  const isPusherChannelDataPolledOrAvailabilityChecked = getLiveStreamData(
    state,
    [userId],
    'isPusherChannelDataPolledOrAvailabilityChecked'
  );
  const fetchLiveStreamAvailabilityId = getLiveStreamData(
    state,
    [userId],
    'fetchLiveStreamAvailabilityId'
  );
  const isLiveStreaming = getLiveStreamData(state, [userId], 'isLiveStreaming');
  const isExclusive = getLiveStreamData(state, [userId], 'isExclusive');
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );

  const publicUrlHostname = getPublicUrlHostname(state);

  return {
    meId,
    username,
    avatarColor: getUserData(state, userId, 'avatarColor'),
    displayedUsername: getUsername(state, userId, 'displayNameFirst'),
    formattedViewers,
    isAuthed,
    languageBadges: getLiveStreamLanguageBadges(
      state,
      streamId,
      getCurrentLanguage()
    ),
    locationKey,
    isLocationKeyTranslationFetched: getNetworkingData(
      state,
      ['translation', locationKey, i18n.language],
      'isFetched'
    ),
    fetchLiveStreamAvailabilityId,
    isLiveStreaming: isPusherChannelDataPolledOrAvailabilityChecked
      ? Boolean(isLiveStreaming)
      : isLiveStreaming,
    isKaraokeDeviceOnline: getIsToyDeviceOnline(state, streamId),
    publicBadgeUrlPath: getRemoteConfigData(state, PUBLIC_BADGE_URL_PATH),
    publicUrlHostname,
    liveStreamFeed: getRemoteConfigData(state, LIVESTREAM_FEED),
    sessionId: getLiveStreamData(state, [streamId], 'sessionId'),
    streamStatus: getLiveStreamData(state, [streamId], 'status'),
    privateShowStatus: getPrivateShowStatus(state, streamId),
    badges: getUserData(state, userId, 'livestreamCardBadges'),
    countries: getUserBadges(state, userId, 'countries'),
    countryFlags: getUserBadges(state, userId, 'countryFlags'),
    isExclusivePrivateOngoing:
      [
        ExclusivePrivateStatus.PERFORMING,
        ExclusivePrivateStatus.PREPARING,
      ].includes(exclusivePrivateStatus) || isExclusive,
    isLiveStreamSnapshotEnabled: getRemoteConfigData(
      state,
      FEATURE_LIVESTREAM_SNAPSHOT
    ),
    isOnLivestreamDetail: getIsMatchedPathname({
      pathname,
      dataKey: 'isOnLivestreamDetail',
    }),
    isAudioLive: getIsAudioLive(state, userId),
  };
};

const mapDispatchToProps = (dispatch, { userId }) => {
  return {
    push: ({ pathname, state }) => dispatch(push(pathname, state)),
    replace: ({ pathname, state }) => dispatch(replace(pathname, state)),
    fetchUser: () => dispatch(fetchUser({ id: userId })),
    fetchLiveStreamAvailability: ({ fetchLiveStreamAvailabilityId }) =>
      dispatch(
        fetchLiveStreamAvailability({ fetchLiveStreamAvailabilityId, userId })
      ),
    fetchTranslationByKey: ({ key }) =>
      dispatch(fetchTranslationByKey({ key })),
    fetchRetainedEvents: ({ channels }) =>
      dispatch(fetchRetainedEvents({ channels })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LiveStreamCard)
);
